import { render } from "./Viewing.vue?vue&type=template&id=037bcfe6"
import script from "./Viewing.vue?vue&type=script&lang=js"
export * from "./Viewing.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__